import React, { useState } from 'react';
import { Typography, Grid, Paper, Box, Button, Modal } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { cancelCycleApi, createOrUpdateCycleApi, getPatientDetailsApi } from '../../../api/patientApi';
import { toast } from 'sonner';
import { resetPatientData, setPatientData, setPatientDataCurrentCycle, setSelectedPatientData } from '../../../actions';
import { currentCycleIntitialState } from '../../../reducers/clinicalReducer';

export default function CycleHistorySheet() {
  const [openModal, setOpenModal] = useState(false); // State to control modal visibility
  const patientData = useSelector((state) => state.clinicalReducer);
  const intermediateData = patientData.selectedPatientData.patient;
  const cycleId = patientData?.currentCycle?.cycleId;
  // Function to handle button click
  const handleStartCycleClick = () => {
    setOpenModal(true);
  };

  // Function to handle modal close
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const pauseCyclesHandler = () => {
    //make api call to pause all previous cycles
    console.log('Cycle paused');
  };
  const dispatch = useDispatch();
  const createNewCycleHandler = async () => {

    if(cycleId) {
      await cancelCycleApi(cycleId);
    }

    dispatch(resetPatientData()); 
    await createOrUpdateCycleApi(
      intermediateData.id,
      null,
      currentCycleIntitialState.fetSheet,
      currentCycleIntitialState.fmsData,
      dispatch,
    );
    setTimeout(async () => {
      const response = await getPatientDetailsApi(intermediateData.id);
      dispatch(setSelectedPatientData(response.data));
    }, 500);

    toast.success('New Cycle Created Successfully');
    pauseCyclesHandler();
    handleCloseModal();
}

  return (
    <Paper sx={{ padding: 3, marginBottom: 3, boxShadow: 3, borderRadius: 2 }}>
      <Grid container spacing={2}>
        {/* Heading */}
        <Grid item xs={12}>
          <Typography variant="h5" align="center" gutterBottom>
            Cycle History Sheet
          </Typography>
        </Grid>

        {/* Patient Information */}
        <Grid item xs={12}>
          <Box flex="1 1 100%" sm="1 1 66%">
            <Typography variant="body1" gutterBottom>
              <strong>Name:</strong> {intermediateData.firstName}{' '}
              {intermediateData.lastName}
              {/* {selectedPatientData.patient.partner.firstName}{' '}
              {selectedPatientData.patient.partner.lastName} */}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Phone:</strong> {intermediateData.phone}
              {/* {selectedPatientData.patient.partner.phone} */}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>MPID:</strong> {intermediateData.upid}
              {/* {selectedPatientData.patient.upid} */}
            </Typography>
          </Box>
        </Grid>

        {/* Start Cycle Button */}
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" sx={{ marginTop: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleStartCycleClick}
            >
              Start Cycle
            </Button>
          </Box>
        </Grid>
      </Grid>

      {/* Modal for confirming cycle start */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Do you want to create a new cycle? It will stop the current ongoing
            cycle.
          </Typography>
          <Box display="flex" justifyContent="flex-end">
            <Button onClick={handleCloseModal} color="primary" sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={createNewCycleHandler}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
    </Paper>
  );
}
